import { getCookie } from "cookies-next";
import {
  LOGICAL_GROUP_CHANNEL_CODE,
  RETAIL_LOGICAL_GROUP_CHANNEL_CODE,
} from "src/constants/logicalGroupChannelCode";
import { S_REF_CODE } from "src/constants/params";
import { ReferenceType } from "src/types/checkout";
import { snakeToCamelCase } from "./format";

/**
 * Retrieves UTM parameters from cookies and returns them in a camelCase formatted object.
 *
 * @return {ReferenceType}
 */
export const utmCheckout = (channelPath: string): ReferenceType => {
  const keyPrefix =
    LOGICAL_GROUP_CHANNEL_CODE === RETAIL_LOGICAL_GROUP_CHANNEL_CODE
      ? "utm_"
      : `${channelPath}_utm_`;
  const utmSource = getCookie(`${keyPrefix}source`);
  const utmMedium = getCookie(`${keyPrefix}medium`);
  const utmCampaign = getCookie(`${keyPrefix}campaign`);
  return {
    utmSource,
    utmMedium,
    utmCampaign,
  };
};

export const getSRefCode = (channelPath: string): string => {
  const keyPrefix =
    LOGICAL_GROUP_CHANNEL_CODE === RETAIL_LOGICAL_GROUP_CHANNEL_CODE
      ? ""
      : `${channelPath}_`;
  return getCookie(`${keyPrefix}${S_REF_CODE}`);
};

/**
 * Formats the given object by converting the keys that start with "utm" to camel case.
 *
 * @param {object} obj - The object to be formatted.
 * @return {object} The formatted object with keys in camel case.
 */
export const formatUtmParams = (obj: object): object => {
  const formattedObject = {};

  for (const [key, value] of Object.entries(obj)) {
    if (key.startsWith("utm")) {
      const camelKey = snakeToCamelCase(key);
      formattedObject[camelKey] = value;
    }
  }

  return formattedObject;
};
